import { create } from 'zustand'

/**
 * archiveViewStore — tracks whether the dashboard is currently
 * rendering a frozen past-week view, and if so, which snapshot.
 *
 * When `active` is true:
 *   - useGoalsData / useMetaData return the archived versions
 *   - useIsReadOnly returns true (every edit surface should no-op)
 *   - A sticky yellow banner announces "Viewing week of X" with
 *     prev/next/close controls
 *
 * When `active` is false:
 *   - Everything behaves normally (live data, full edit rights)
 *
 * The snapshot itself lives in meta.weeklyHistory[weekKey] — we don't
 * duplicate it in the store. Only the `weekKey` pointer is stored; the
 * lookup is derived at read time so cache updates propagate naturally.
 */
export const useArchiveViewStore = create((set, get) => ({
  active: false,
  weekKey: null,

  enterArchive: (weekKey) => {
    if (!weekKey) return
    set({ active: true, weekKey })
  },

  exitArchive: () => set({ active: false, weekKey: null }),

  /** Swap to a different week while staying in archive mode. */
  setWeekKey: (weekKey) => {
    if (!weekKey) return
    set({ active: true, weekKey })
  },
}))

/**
 * useIsReadOnly — thin selector so edit-surface components only
 * re-render when the readOnly flag flips, not on every store update.
 */
export function useIsReadOnly() {
  return useArchiveViewStore((s) => s.active)
}
